var _path, _line, _line2, _line3, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 252,
    viewBox: "0 0 229 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 156.5L138.5 239L220 153V130.5H153L110.5 12.5L54.5 13.5V36.5L73.5 130.5H11.5V156.5Z",
    fill: "#4db5ff",
    stroke: "#000000"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 138.5,
    y1: 239,
    x2: 138.5,
    y2: 210,
    stroke: "#000000"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 138.649,
    y1: 210.644,
    x2: 219.649,
    y2: 130.644,
    stroke: "#000000"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 138.731,
    y1: 211.422,
    x2: 11.7311,
    y2: 130.422,
    stroke: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5 130.5H81L55 13.5",
    stroke: "#000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.d16bdc7e.svg";
export { ForwardRef as ReactComponent };